module.exports = __webpack_public_path__ + "img/appBarMovileMultihogar.59c18355.png";